import { MainPageDiv } from "utilFunctions/shared/StyledComponent/StyledComponent";
import LeftArrow from "Assets/Icons/LeftArrow";
import { useNavigate } from "react-router-dom";
import Typography from "Components/CommonComponents/Typography";
import { StyledMainDiv } from "Pages/DeveloperTools/DeveloperToolsMain";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { useContext, useEffect, useState } from "react";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { UserInfoContext } from "Context/CommonContext";
import {
  BASE_URL,
  FETCH_LOP_REGIONS,
} from "utilFunctions/Constants/urlConstants";
import LopReasonsTable, {
  LopReason,
} from "Pages/DeveloperTools/LopReasons/LopReasonsTable";
import { Button, Spin } from "antd";

const LopReasons = () => {
  const userInfo = useContext<any>(UserInfoContext);
  const navigate = useNavigate();
  const { screen }: any = useWindowSize();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [lopReasons, setLopReasons] = useState<LopReason[]>([]);
  const { makeRequest: GetLopReasons, loading: pageLoading } = useGetApi(
    (searchData: any) => {
      if (
        searchData &&
        searchData != null &&
        searchData["data"] &&
        searchData["data"].length
      ) {
        setLopReasons(searchData["data"]);
      }
    },
    (error: any) => {
      onFetchError(error);
    }
  );

  const onFetchError = (error: any) => {
    console.log("erorr onFetchError", error);
  };
  const callAPI = () => {
    const url = BASE_URL + FETCH_LOP_REGIONS;
    GetLopReasons(url);
  };

  useEffect(() => {
    if (userInfo.employeeId) {
      callAPI();
    }
  }, [userInfo]);
  if (pageLoading) {
    return <Spin fullscreen></Spin>;
  }
  return (
    <MainPageDiv screen={screen}>
      <StyledMainDiv
        screen={screen}
        style={{ justifyContent: "space-between" }}
      >
        <div className="d-flex">
          <LeftArrow
            className={"cursorHoverCSS mr-3"}
            onClick={() => {
              navigate("/admin/dashboard", {
                replace: true,
                state: {
                  selectedStudent: null,
                },
              });
            }}
          />
          <Typography variant={"h6"} color="black">
            Lop Reasons
          </Typography>
        </div>
        <Button type="primary" onClick={() => setIsModalVisible(true)}>
          Add Reason
        </Button>
      </StyledMainDiv>
      <LopReasonsTable
        lopReasons={lopReasons}
        setLopReasons={setLopReasons}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      ></LopReasonsTable>
    </MainPageDiv>
  );
};

export default LopReasons;
